import { Component, EventEmitter, Output, Input } from '@angular/core';
import { TimeFrameMode } from '../../interfaces/global-filter-model';
import { MondelezDataService } from '../../services/mondelez-data.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-custom-toggle-btn',
  templateUrl: './custom-toggle-btn.component.html',
  styleUrls: ['./custom-toggle-btn.component.scss'],
})
export class CustomToggleBtnComponent {
  @Output() onChangeTimeFrame = new EventEmitter<TimeFrameMode>();
  @Input() isRightPosition: boolean;

  public timeFrameMode: TimeFrameMode = TimeFrameMode.YEARLY;
  private subs = new Subscription();

  constructor(private mondelezDataService: MondelezDataService) {}

  ngOnInit(): void {
    this.subs.add(
      this.mondelezDataService.timeFrameMode.subscribe((value) => {
        this.timeFrameMode = value;
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public onTimeFrameChange(value) {
    this.timeFrameMode = value;
    this.onChangeTimeFrame.emit(value);
  }
}
